
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://mwztymqscvifvnfhxnip.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im13enR5bXFzY3ZpZnZuZmh4bmlwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTIxNjcyOTYsImV4cCI6MjA2Nzc0MzI5Nn0.w1xUXR9HyXRymI6E0tEov0z00f0O0CRD2xDK3a7SG0A";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});

// RLS detection tracking
let rlsDetected = false;

// Bucket creation utilities
export const ensureBucketExists = async (bucketName: string, isPublic: boolean = true) => {
  try {
    // Check if bucket exists
    const { data: buckets, error: listError } = await supabase.storage.listBuckets();
    
    if (listError) {
      console.error('Error listing buckets:', listError);
      return { success: false, error: listError };
    }
    
    const bucketExists = buckets?.some(bucket => bucket.name === bucketName);
    
    if (bucketExists) {
      console.log(`Bucket ${bucketName} already exists`);
      return { success: true };
    }
    
    // Create bucket if it doesn't exist
    const { data, error } = await supabase.storage.createBucket(bucketName, {
      public: isPublic,
      allowedMimeTypes: ['image/*', 'video/*'],
      fileSizeLimit: 52428800, // 50MB
    });
    
    if (error) {
      console.error(`Error creating bucket ${bucketName}:`, error);
      if (error.message?.includes('row-level security policy')) {
        rlsDetected = true;
      }
      return { success: false, error };
    }
    
    console.log(`Successfully created bucket ${bucketName}`);
    return { success: true, data };
  } catch (error) {
    console.error(`Exception creating bucket ${bucketName}:`, error);
    return { success: false, error };
  }
};

// RLS detection utility
export const hasDetectedRLS = () => {
  return rlsDetected;
};

// Public URL utility
export const getCorrectPublicUrl = (bucket: string, path: string) => {
  const { data } = supabase.storage.from(bucket).getPublicUrl(path);
  return data.publicUrl;
};
